var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modalCertificate","ok-only":"","centered":"","size":"lg","title":_vm.item.title},on:{"hidden":function($event){return _vm.closeModal()}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.item.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }